import {Injectable} from "@angular/core";
import {Actions, createEffect, Effect, ofType} from "@ngrx/effects";
import {EApplicationParametersActions, SetLanguage} from "../../actions/application-parameters/application-parameters.actions";
import {tap, withLatestFrom} from "rxjs/operators";
import {IAppState} from "../../state/app.state";
import {Store} from "@ngrx/store";
import {TranslateResources} from "../../actions/resources/resources.actions";


@Injectable()
export class LanguageEffects {
  Language$ =  createEffect(() => this._actions$.pipe(
    ofType<SetLanguage>(EApplicationParametersActions.SetLanguage),
    withLatestFrom(this._store$),
    tap(
      ([action,storeState]) =>{
        this._store$.dispatch( new TranslateResources(storeState.language.currentLanguage));
        console.log('SetLanguage effect');
      }
    )
  ),{dispatch: false});


  constructor(
    private _actions$: Actions,
    private _store$: Store<IAppState>
  ) {}

}

